import React from "react";
import { Link } from 'react-router-dom';
import { MenuItems } from "./MenuItems";
import { ReactComponent as Logo } from "../../resources/small_logo.svg";
import "./Navbar.css";

function Navbar() {
  const [isClicked] = React.useState(false);

  return (
    <div className="outside">
      <nav className="navbar-container">
        <a href="/">
          <Logo className="logo" />
        </a>
        <ul className={isClicked ? "nav-menu active" : "nav-menu"}>
          {MenuItems.map((item, index) => {
            return (
              <li key={index}>
                <Link className={item.cName} to={item.url}>{item.title}</Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}

export default Navbar;
